export default function parseNumberSaturation(value: string): number {
  return Number(value);
}
